import React from 'react';
export const BenefitsSection = () => {
  return <section className="bg-gradient-to-b from-teal-700 to-teal-800 text-white py-16" data-id="element-22">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-23">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center" data-id="element-24">
          You Won't Just Feel Calmer. You'll Feel <em data-id="element-25">Different.</em>
        </h2>
        <div className="mb-10" data-id="element-26">
          <p className="mb-6 text-lg" data-id="element-27">This program helps you:</p>
          <ul className="list-disc pl-6 space-y-4 mb-10 text-lg" data-id="element-28">
            <li data-id="element-29">Sleep deeper and wake up rested</li>
            <li data-id="element-30">Stop dissociating under stress</li>
            <li data-id="element-31">Feel more present in relationships</li>
            <li data-id="element-32">Get out of chronic freeze, without overwhelm</li>
            <li data-id="element-33">Build real, daily resilience</li>
          </ul>
          <div className="bg-white bg-opacity-10 p-6 rounded-lg italic mb-4" data-id="element-34">
            <p className="mb-4" data-id="element-35">
              "Before Neurotoned, I was constantly dissociating under
              stress—even though I'd read every book and followed all the
              somatic accounts. By Day 4 of the program, I felt grounded during
              an argument with my partner for the first time in years."
            </p>
            <p className="text-right" data-id="element-36">
              — Laura D., Social Worker & Trauma Survivor
            </p>
          </div>
        </div>
      </div>
    </section>;
};